import React, { useState } from "react";

import PropTypes from "prop-types";

import { PopoverContent } from "shared/components/Form/Input/styled";
import Icon from "shared/components/Icon";
import { Popover } from "shared/components/Popover";
import { basicPropertyPropType } from "shared/utils/propTypes";

import { sectionType } from "../../shared/propTypes";
import {
  veroUnitsPropType,
  yardiUnitsPropType,
} from "../../shared/yardi.config";

import {
  useUnitConfigSection,
} from "./configureYardiPropertySection.util";
import {
  Section,
  SectionTitle,
  SectionSubTitle,
  RowLabelContainer,
} from "./styled";
import { YardiUnitsConfigSection } from "./YardiUnitsConfigSection";

const YardiSectionOtherUnits = ({
  section,
  veroUnits,
  veroUnitsMap,
  yardiUnits,
  veroProperty,
  yardiProperty,
  firstColWidth,
  loading,
  provider,
}) => {
  const [checkedItems, setCheckedItems] = useState([]);

  const buildPropPath = (yardiUnit) =>
    `otherUnits[${yardiUnit.id}]`;

  const buildLabel = (yardiUnit) => (
    <RowLabelContainer>
      <span className="label-without-input" title={yardiUnit.name}>
        {yardiUnit.name}
      </span>
    </RowLabelContainer>
  );

  const { tableItems, autoCreateUnits, isAutocreating } = useUnitConfigSection(
    provider,
    buildPropPath,
    buildLabel,
    veroUnits,
    veroUnitsMap,
    yardiUnits,
    veroProperty,
    yardiProperty,
    checkedItems
  );

  return (
    <>
      <Section height="auto" noPaddingBottom>
        <SectionTitle>{section.name}</SectionTitle>
        <SectionSubTitle>
          <div>
            The units below are not currently listed as available within your
            External Provider but you can still link them to a VERO unit.
            <Popover
              className="popover"
              withoutOverlay
              content={
                <PopoverContent>
                  If you do not link them at this time you will have another
                  opportunity to do so when they become an available unit within
                  your External Provider.
                </PopoverContent>
              }
            >
              <Icon.InfoIcon />
            </Popover>
          </div>
        </SectionSubTitle>
        <YardiUnitsConfigSection
          sectionId={section.anchor}
          items={tableItems}
          popoverText="When auto creating units in VERO we will use the unit name provided by the External Provider."
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
          autoCreateUnits={autoCreateUnits}
          firstColWidth={firstColWidth}
          loading={loading || isAutocreating}
        />
      </Section>
    </>
  );
};

YardiSectionOtherUnits.propTypes = {
  section: sectionType.isRequired,
  veroUnits: veroUnitsPropType,
  veroUnitsMap: PropTypes.object.isRequired,
  yardiUnits: yardiUnitsPropType,
  veroProperty: basicPropertyPropType,
  yardiProperty: basicPropertyPropType,
  firstColWidth: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  provider: PropTypes.string.isRequired,
};

YardiSectionOtherUnits.defaultProps = {
  veroUnits: [],
  yardiUnits: [],
  veroProperty: null,
  yardiProperty: null,
  loading: false,
};

export default YardiSectionOtherUnits;
